module.exports = __webpack_public_path__ + "img/skipio-2.88c6ceaa.jpg";